export const getRedirectUri = (path?: string): string => {
  const { protocol, hostname, port, pathname } = window.location;
  const uriPath = path || pathname;
  const redirectUri = `${protocol}//${hostname}${port ? `:${port}` : ''}${uriPath}`;

  return redirectUri;
};
